module.exports = __webpack_public_path__ + "img/pack.dbc4e651.webp";